<template>
    <div class="NavigationBar-box container">
        <div class="NavigationBar-content-box">
            <component :is="'div'" class="navigation-image-box"  >
                <el-image :style="{
                    width: `${config.imgWidth}px`,
                    height: `${config.imgHeight}px`,
                }"
                         referrerpolicy="no-referrer"
                class="image-item" :src="config.imgURL" :fit="config.fit" />
            </component>

            <div class="navigation-item-content visible-max-block">
                <div class="navigation-item-box">
                    <div class="navigation-item" v-for="(item, index) in navigationList" :key="index">
                        <NuxtLink 
                            :class="{
                                'navigation-item-title': true,
                                'navigation-item-title-active': actionIndex === index,
                                ['navigation-item-title-' + index]: true
                            }"
                            :style="{
                                fontSize: (config.textConfigs.fontSize || 18) + 'px',
                                fontWeight: (config.textConfigs.fontWeight || 'normal'),
                                color: (actionIndex === index ?
                                    config.textConfigs.fontActionColor || '#346bd2'
                                    : config.textConfigs.fontColor || '#333'),
                            }"
                            :to="item.linkUrl" 
                            :target="getJumpType(item,true)"
                        >
                            {{ getLocaleText(item.title) }}
                        </NuxtLink>
                    </div>
                </div>
            </div>

            <div class="navigation-item-content visible-min-block">
                <div class="the-small-screen-container">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                        @select="handleSelect">
                        <el-submenu index="1">
                            <template #title>
                                <i class="el-icon-s-unfold"></i>
                            </template>
                            <el-menu-item v-for="(item, index) in navigationList" :key="index" :index="`1-${index}`">
                                <NuxtLink 
                                :class="{
                                    'navigation-item-title': true,
                                    ['navigation-item-title-' + index]: true
                                }"
                                :style="{
                                    fontSize: (config.textConfigs.fontSize || 18) + 'px',
                                    fontWeight: (config.textConfigs.fontWeight || 'normal'),
                                    color: (actionIndex === index ?
                                        config.textConfigs.fontActionColor || '#346bd2'
                                        : config.textConfigs.fontColor || '#333'),
                                }"
                                :to="item.linkUrl"   
                                :target="getJumpType(item,true)"
                                >
                                    {{ getLocaleText(item.title) }}
                                </NuxtLink>
                                
                               
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </div>
        </div>

        <div class="NavigationBar-slot" v-html="config.htmlText"></div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { getTabBarConfigList } from '@/api/index.js'; 
import useLocate from '../uses/useLocate.js';
import { useMainStore } from "~/composables/store";

import { useRoute } from 'vue-router';
const store = useMainStore();
// 引入自定义 mixins (合并到 composable 中)
const { getLocaleText } = useLocate();
 

const props = defineProps({
    parentKeys: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: true,
    },
    config: {
        type: Object,
    },
});

const actionIndex = ref(0);
const activeIndex = ref(null);
const navigationList = ref([]);

const edit = computed(() => !props.disabled);
 
navigationList.value = store.$state.navigationList
 
const route = useRoute();
const getPcNavigatorData = async () => {
    const param = {
        pageNo: 0,
        pageSize: 9999,
        showType: '1',
        status: '1',
    };

    if ((!navigationList.value || !navigationList.value.length) && process.client) {
        const res = await getTabBarConfigList(param);
        if (res.data && res.data.dataList) {
            const list = res.data.dataList.sort((a, b) => {
                const aSort = a.sortNo ?? 0;
                const bSort = b.sortNo ?? 0;
                return aSort - bSort;
            });
            navigationList.value = list;
        }
    } 

 
    const currentPageAddress = typeof window !== 'undefined' ? window.location.href.replace(window.location.origin, '') : '';
    navigationList.value.find((item, index) => {
        if (currentPageAddress.indexOf(item.linkUrl) !== -1) {
            actionIndex.value = index;
        }
    });
};
watch(
    () => props.config.itemConfigs,
    async (value) => {
        if (value) {
            await getPcNavigatorData();
        }
    },
    { deep: true  }
);
watch(
    () => route,
    async (value) => {
        if (value) {
            await getPcNavigatorData();
        }
    },
    { deep: true  }
);


onMounted(() => {
    if (typeof window !== 'undefined') {
        if (!window.pageTabs) {
            window.pageTabs = {};
        }
        window.pageTabs[props.config.id] = {
            setTab,
            getTab,
        };
    }

    getPcNavigatorData();


});



const getTab = () => activeIndex.value;
const setTab = (i) => {
    if (props.config.navigationItemConfigs[i]) {
        activeIndex.value = props.config.navigationItemConfigs[i].config.text + i;
    }
};
const getJumpType = (item,isNuxtLink) => {
    let jumpWay = '_Self';
    switch (item.linkType) {
        case 0:
            jumpWay = '_Blank';
            break;
        case 10:
            jumpWay = '_Self';
            break;
    }
    if(isNuxtLink&&jumpWay == '_Self'){
        return undefined;
    }
    return jumpWay;
}

const navigationClickFn = (item, index) => {
    if (!item) return;
    actionIndex.value = index;
    let jumpWay = getJumpType(item);
     
    if (item.linkUrl) {
        window.open(item.linkUrl, jumpWay);
    }
};

const handleSelect = (value) => {
    // handle select logic
};
</script>

<style scoped>
@media (max-width: 767px) {
    .visible-max-block {
        display: none !important;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .visible-max-block {
        display: none !important;
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .visible-min-block {
        display: none !important;
    }
}

@media screen and (min-width: 1199px) {
    .visible-min-block {
        display: none !important;
    }
}

.NavigationBar-box {
    overflow: hidden;
    width: 100%;
    user-select: none;
    padding: 0;
    margin: 0;
}

.category-column {
    display: flex;
    align-items: center;
}

.category-item-icon {
    width: 2rem;
    height: 2rem;
}

.NavigationBar-content-box {
    display: flex;
    align-items: center;
    min-height: 70px;
}

.navigation-item-content {
    flex: 1;
    -o-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}

.navigation-item-box {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-around;
    align-items: center;
}

.navigation-item {
    display: inline-block;
    cursor: pointer;
}

.navigation-item-title {
    text-decoration: none;
    display: inline-block;
}

.navigation-item-title.is-action {
    color: rgb(41, 106, 182);
}

.the-small-screen-container {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    align-items: center;
}

:deep(.the-small-screen-container .el-submenu__title) {
    border-bottom: 0px;
}

:deep(.the-small-screen-container .el-menu.el-menu--horizontal ){
    border-bottom: 0px;
}
</style>